/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progression_Soreness_Volume_CutInputs */

const en_us2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduced for soreness`)
};

const pt_br2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduzido por causa da dor`)
};

const es_419_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen reducido por el dolor`)
};

const pt_pt2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume reduzido por causa da dor`)
};

const fr_fr2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume réduit à cause des courbatures`)
};

const de_de2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volumen wegen Muskelkater reduziert`)
};

const it_it2_progression_soreness_volume_cut = /** @type {(inputs: Progression_Soreness_Volume_CutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume ridotto per l'indolenzimento`)
};

/**
* | output |
* | --- |
* | "Volume reduced for soreness" |
*
* @param {Progression_Soreness_Volume_CutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progression_soreness_volume_cut = /** @type {((inputs?: Progression_Soreness_Volume_CutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progression_Soreness_Volume_CutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progression_soreness_volume_cut(inputs)
	if (locale === "es-419") return es_419_progression_soreness_volume_cut(inputs)
	if (locale === "pt-PT") return pt_pt2_progression_soreness_volume_cut(inputs)
	if (locale === "fr-FR") return fr_fr2_progression_soreness_volume_cut(inputs)
	if (locale === "de-DE") return de_de2_progression_soreness_volume_cut(inputs)
	if (locale === "it-IT") return it_it2_progression_soreness_volume_cut(inputs)
	return en_us2_progression_soreness_volume_cut(inputs)
});
export { progression_soreness_volume_cut as "progression.soreness_volume_cut" }